import * as $$ from "jquery-selector-cache";
import {openPopinMap} from "../popinMap/popinMap";

/**
 * Initialize the information product
 */
function initInformationsProduct() {
    if (!$$(".cpt-informations-product").length) {
        return;
    }

    // Event
    $$(".cpt-informations-product").on("click.openPopinMap", ".geo-information", handleOpenPopinMap);
}

/**
 * Handler of open popin map
 * @param evt
 */
function handleOpenPopinMap(evt: JQuery.ClickEvent<HTMLDivElement>) {
    const lngLatData = $(evt.currentTarget).data("geoLngLat");
    if (!lngLatData) {
        return;
    }

    const split = lngLatData.split(",");
    const lngLat: [number, number] = [Number(split[0]), Number(split[1])];

    openPopinMap({
        "lngLat": lngLat,
    });
}

export {
    initInformationsProduct,
};
